import React from 'react';
import { useIntl } from 'react-intl';
import cn from 'classnames';
import { get, map } from 'lodash';

import { MAPPING_PERIOD } from '../../../constants';
import type { WidgetType } from '../../../types';

import './mobileHeader.scss';

interface Props {
    periods: WidgetType[];
    activeZoneIndex: WidgetType;
    makeHandleActiveZoneIndex: (zoneIndex: WidgetType) => VoidFunction;
}

const MobileHeader: React.FC<Props> = ({
    periods,
    activeZoneIndex,
    makeHandleActiveZoneIndex,
}) => {
    const { formatMessage } = useIntl();

    return (
        <div styleName="container">
            {map(periods, type => {
                const period = get(MAPPING_PERIOD, type, undefined);

                return (
                    <div
                        key={type}
                        styleName={cn('item', {
                            'active-item': type === activeZoneIndex,
                        })}
                        onClick={makeHandleActiveZoneIndex(type)}
                    >
                        {period ? formatMessage(period) : type}
                    </div>
                );
            })}
        </div>
    );
};

export default React.memo(MobileHeader);
